import React, { useState } from "react";

import Template from "./InputTextarea.jsx";

const InputController = (props) => {
  const [focus, setFocus] = useState(false);

  const onBlur = (e) => {
    const { onBlur } = props;

    setFocus(false);
    onBlur && onBlur(e);
  };

  const onFocus = (e) => {
    const { onFocus } = props;

    setFocus(false);
    onFocus && onFocus(e);
  };

  const handlers = {
    onFocus,
    onBlur,
  };
  return <Template {...props} focus={focus} {...handlers} />;
};

export default InputController;
